export default "__VITE_ASSET__CSttofsS__"